import { inject as a } from "vue";
function r() {
  const { onOverlayActive: e, onOverlayInactive: o } = a("dsOverlay");
  function t() {
    document.body.classList.add("overlay-active"), e();
  }
  function n() {
    document.body.classList.remove("overlay-active"), o();
  }
  return { open: t, close: n };
}
export {
  r as default
};
//# sourceMappingURL=design-system.es142.js.map
